/* ============================================================================
   stp-difference.js — behaviour for the Difference sections, site-wide
   Sheng Tang Peony · build 2026-11-04-a

   Loaded deferred from layout/theme.liquid. Every part looks for its own
   data-sx-* hook and does nothing when it is not on the page.
     1. --sx-hh   height of the stuck header, for the sticky titles and bars
     2. open/close rows            [data-sx-acc]
     3. the collection controls    [data-sx-col]
     4. the product form           [data-sx-product]
     5. the cart drawer            [data-sx-cart]  (snippets/stp-cart-drawer.liquid)
   ========================================================================== */
(function () {
  'use strict';
  var doc = document.documentElement;

  /* ---------- 1. header height ---------- */
  function headH() {
    var sec = document.querySelector('.section-header');
    if (!sec) { return 0; }
    var wrap = sec.querySelector('.header-wrapper') || sec;
    var pos = window.getComputedStyle(sec).position;
    if ((pos !== 'sticky' && pos !== 'fixed') || sec.classList.contains('shopify-section-header-hidden')) { return 0; }
    return Math.max(0, Math.round(wrap.getBoundingClientRect().bottom));
  }
  var hhRaf = 0;
  function setHH() { hhRaf = 0; doc.style.setProperty('--sx-hh', headH() + 'px'); }
  function queueHH() { if (!hhRaf) { hhRaf = window.requestAnimationFrame(setHH); } }
  window.addEventListener('scroll', queueHH, { passive: true });
  window.addEventListener('resize', queueHH);
  setHH();

  /* ---------- 2. open/close rows ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sx-acc]');
    if (!b) { return; }
    var d = b.nextElementSibling;
    if (!d) { return; }
    d.hidden = !d.hidden;
    b.setAttribute('aria-expanded', d.hidden ? 'false' : 'true');
    var s = b.querySelector('[data-sx-sign]');
    if (s) { s.textContent = d.hidden ? '+' : '−'; }
  });

  /* ---------- 3. collection ---------- */
  [].forEach.call(document.querySelectorAll('[data-sx-col]'), function (root) {
    var form = root.querySelector('[data-sx-form]');
    var grid = root.querySelector('[data-sx-grid]');
    var phone = window.matchMedia('(max-width: 749px)');
    var openers = root.querySelectorAll('[data-sx-open]');
    function sheet(name) {
      [].forEach.call(openers, function (b) {
        var on = b.getAttribute('data-sx-open') === name && b.getAttribute('aria-expanded') !== 'true';
        b.setAttribute('aria-expanded', on ? 'true' : 'false');
        var s = root.querySelector('[data-sx-sheet="' + b.getAttribute('data-sx-open') + '"]');
        if (s) { s.hidden = !on; }
      });
    }
    [].forEach.call(openers, function (b) { b.addEventListener('click', function () { sheet(b.getAttribute('data-sx-open')); }); });

    /* how many per row, remembered separately for phone and desktop */
    var vb = root.querySelectorAll('[data-sx-cols]');
    function key() { return phone.matches ? 'sx-cols-p' : 'sx-cols-d'; }
    function setCols(n, save) {
      if (!grid) { return; }
      grid.style.setProperty('--cols', n);
      [].forEach.call(vb, function (b) {
        var want = phone.matches ? b.getAttribute('data-sx-cols-p') : b.getAttribute('data-sx-cols');
        b.setAttribute('aria-pressed', String(want) === String(n) ? 'true' : 'false');
      });
      if (save) { try { localStorage.setItem(key(), n); } catch (e) {} }
    }
    function initCols() {
      var n = null;
      try { n = localStorage.getItem(key()); } catch (e) {}
      setCols(n || (phone.matches ? 2 : 4), false);
    }
    [].forEach.call(vb, function (b) {
      b.addEventListener('click', function () { setCols(phone.matches ? b.getAttribute('data-sx-cols-p') : b.getAttribute('data-sx-cols'), true); });
    });
    if (phone.addEventListener) { phone.addEventListener('change', initCols); }
    initCols();

    if (!form) { return; }
    function params() {
      var out = new URLSearchParams();
      new FormData(form).forEach(function (v, k) {
        v = String(v).trim();
        if (v === '') { return; }
        if (k.indexOf('filter.v.price') === 0) { v = v.replace(',', '.'); }
        out.append(k, v);
      });
      return out;
    }
    function go() { var q = params().toString(); window.location.href = root.getAttribute('data-url') + (q ? '?' + q : ''); }
    form.addEventListener('submit', function (e) { e.preventDefault(); go(); });
    [].forEach.call(root.querySelectorAll('[data-sx-sort]'), function (r) { r.addEventListener('change', go); });

    /* "Show N pieces": ask the store how many match before committing */
    var show = root.querySelector('[data-sx-show]');
    var t = 0, seq = 0;
    function recount() {
      if (!show) { return; }
      var mine = ++seq, q = params();
      q.set('section_id', root.getAttribute('data-section-id'));
      fetch(root.getAttribute('data-url') + '?' + q.toString(), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
        .then(function (txt) {
          if (mine !== seq) { return; }
          var m = txt.match(/data-sx-total="(\d+)"/);
          if (!m) { return; }
          var n = parseInt(m[1], 10);
          show.textContent = show.getAttribute('data-label') + ' ' + n + ' ' + show.getAttribute(n === 1 ? 'data-one' : 'data-many');
        })
        .catch(function () {});
    }
    form.addEventListener('change', function (e) {
      if (e.target.hasAttribute('data-sx-sort')) { return; }
      clearTimeout(t); t = setTimeout(recount, 250);
    });
    form.addEventListener('input', function (e) {
      if (!e.target.hasAttribute('data-sx-price')) { return; }
      clearTimeout(t); t = setTimeout(recount, 500);
    });
  });

  /* ---------- money, in the shop's own format ---------- */
  var MONEY = (window.SX && window.SX.money) || '€{{amount_with_comma_separator}}';
  function money(cents) {
    cents = Number(cents) || 0;
    function fmt(n, d, t, s) {
      var str = (n / 100).toFixed(d), parts = str.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return parts[1] ? parts[0] + s + parts[1] : parts[0];
    }
    return MONEY.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2, ',', '.');
      }
    });
  }

  /* ---------- 5. cart drawer ---------- */
  var drawer = document.querySelector('[data-sx-cart]');
  var ov = document.querySelector('[data-sx-ov]');
  var cart = null;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function sized(url, w) { if (!url) { return ''; } return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function refreshBubble() {
    fetch('/?sections=cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (j) {
        var el = document.getElementById('cart-icon-bubble'), html = j && j['cart-icon-bubble'];
        if (!el || !html) { return; }
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var inner = tmp.querySelector('.shopify-section') || tmp;
        el.innerHTML = inner.innerHTML;
      })
      .catch(function () {});
  }
  function draw() {
    if (!drawer || !cart) { return; }
    var n = cart.item_count;
    drawer.querySelector('[data-sx-ct]').textContent = drawer.getAttribute('data-title') + (n ? ' (' + n + ')' : '');
    var b = drawer.querySelector('[data-sx-cb]'), f = drawer.querySelector('[data-sx-cf]');
    if (!n) {
      b.innerHTML = '<div style="padding:60px 0;text-align:center"><p class="sx-t2">' + esc(drawer.getAttribute('data-empty')) + '</p><a class="sx-t sx-u" href="' + esc(drawer.getAttribute('data-shop')) + '">' + esc(drawer.getAttribute('data-shop-label')) + '</a></div>';
      f.hidden = true;
      return;
    }
    b.innerHTML = cart.items.map(function (it, i) {
      var opts = (it.options_with_values || []).filter(function (o) { return o.value && o.value !== 'Default Title'; }).map(function (o) { return esc(o.value); }).join(' · ');
      return '<div class="sx-li"><a href="' + esc(it.url) + '"><img src="' + esc(sized(it.image, 240)) + '" alt="" loading="lazy"></a><div class="sx-li-c">' +
        '<a class="sx-t" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        '<span class="sx-t2">' + (opts ? opts + ' · ' : '') + money(it.final_price) + '</span>' +
        '<div class="sx-li-r"><span class="sx-qty"><button type="button" data-sx-q="' + (i + 1) + '" data-d="-1" aria-label="One fewer">−</button><span>' + it.quantity + '</span><button type="button" data-sx-q="' + (i + 1) + '" data-d="1" aria-label="One more">+</button></span>' +
        '<button type="button" class="sx-rm sx-t" data-sx-rm="' + (i + 1) + '">' + esc(drawer.getAttribute('data-remove')) + '</button></div></div></div>';
    }).join('');
    f.hidden = false;
    f.querySelector('[data-sx-sub]').textContent = money(cart.total_price);
  }
  function load() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) { cart = j; draw(); return j; });
  }
  function open() {
    if (!drawer) { return; }
    drawer.classList.add('is-on'); ov.classList.add('is-on');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    load();
  }
  function close() {
    if (!drawer) { return; }
    drawer.classList.remove('is-on'); ov.classList.remove('is-on');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }
  function change(line, qty) {
    drawer.classList.add('is-busy');
    fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j && j.items) { cart = j; draw(); } refreshBubble(); })
      .catch(function () {})
      .then(function () { drawer.classList.remove('is-busy'); });
  }
  if (drawer) {
    ov.addEventListener('click', close);
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-sx-close]')) { close(); return; }
      var q = e.target.closest('[data-sx-q]'), rm = e.target.closest('[data-sx-rm]');
      if (q && cart) { var l = +q.getAttribute('data-sx-q'); change(l, Math.max(0, cart.items[l - 1].quantity + +q.getAttribute('data-d'))); }
      if (rm) { change(+rm.getAttribute('data-sx-rm'), 0); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); } });
    /* the header's Cart opens the drawer instead of leaving the page (except on /cart itself) */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('#cart-icon-bubble, .section-header a[href$="/cart"]');
      if (!a || /\/cart\/?$/.test(window.location.pathname)) { return; }
      e.preventDefault();
      open();
    });
  }
  window.SXCart = { open: open, load: load, refreshBubble: refreshBubble };

  /* ---------- 4. product ---------- */
  [].forEach.call(document.querySelectorAll('[data-sx-product]'), function (root) {
    var data;
    try { data = JSON.parse(root.querySelector('[data-sx-pj]').textContent); } catch (e) { return; }
    var variants = data.variants || [], nOpt = (data.options || []).length;
    var chosen = [];
    var cur = variants.filter(function (v) { return v.id === data.selected; })[0] || null;
    var idInput = root.querySelector('[data-sx-id]');
    var add = root.querySelector('[data-sx-add]');
    var padd = root.querySelector('[data-sx-padd]');
    var psel = root.querySelector('[data-sx-psel]');
    var priceEl = root.querySelector('[data-sx-price]');
    var L = { choose: root.getAttribute('data-l-choose'), add: root.getAttribute('data-l-add'), sold: root.getAttribute('data-l-sold'), size: root.getAttribute('data-l-size') };
    if (data.preselect && cur) { chosen = cur.options.slice(); }

    function match() {
      if (chosen.filter(Boolean).length < nOpt) { return null; }
      return variants.filter(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); })[0] || null;
    }
    function paint() {
      cur = match();
      [].forEach.call(root.querySelectorAll('[data-sx-val]'), function (b) {
        var i = +b.getAttribute('data-sx-opt'), val = b.getAttribute('data-sx-val');
        b.setAttribute('aria-pressed', chosen[i] === val ? 'true' : 'false');
        /* is there anything in stock with this value, given the other choices so far? */
        var ok = variants.some(function (v) { return v.available && v.options[i] === val && v.options.every(function (o, k) { return k === i || !chosen[k] || o === chosen[k]; }); });
        b.classList.toggle('is-out', !ok);
      });
      var label, dis = false;
      if (!variants.some(function (v) { return v.available; })) { label = L.sold; dis = true; }
      else if (!cur) { label = L.choose; }
      else if (!cur.available) { label = L.sold; dis = true; }
      else { label = L.add + ' · ' + money(cur.price); }
      if (add) { add.textContent = label; add.disabled = dis; }
      if (padd) { padd.textContent = cur && cur.available ? L.add + ' · ' + money(cur.price) : (dis ? L.sold : L.add); padd.disabled = dis; }
      if (cur) {
        if (idInput) { idInput.value = cur.id; }
        if (priceEl) { priceEl.innerHTML = (cur.compare_at_price > cur.price ? '<s>' + money(cur.compare_at_price) + '</s>' : '') + money(cur.price); }
        if (psel) { psel.value = String(cur.id); }
        try { var u = new URL(window.location.href); u.searchParams.set('variant', cur.id); window.history.replaceState({}, '', u.toString()); } catch (e) {}
        /* the colour row follows the chosen colour */
        var row = root.querySelector('[data-stp-colour]');
        if (row) {
          var on = row.getAttribute('data-stp-colour'), idx = (data.options || []).indexOf(on);
          if (idx > -1 && row.querySelector('strong')) { row.querySelector('strong').textContent = cur.options[idx]; }
        }
      }
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sx-val]');
      if (!b) { return; }
      chosen[+b.getAttribute('data-sx-opt')] = b.getAttribute('data-sx-val');
      paint();
    });
    if (psel) {
      psel.addEventListener('change', function () {
        var v = variants.filter(function (x) { return String(x.id) === psel.value; })[0];
        if (v) { chosen = v.options.slice(); paint(); }
      });
    }
    function addToCart(btn) {
      if (!cur) { btn.textContent = L.choose; return; }
      if (!cur.available) { return; }
      btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: cur.id, quantity: 1 }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) { throw j; } return j; }); })
        .then(function () { refreshBubble(); open(); })
        .catch(function (err) { btn.textContent = (err && err.description) || 'Could not add'; })
        .then(function () { btn.disabled = false; setTimeout(paint, 1800); });
    }
    var form = root.querySelector('[data-sx-pform]');
    if (form) { form.addEventListener('submit', function (e) { if (!drawer) { return; } e.preventDefault(); addToCart(add); }); }
    if (padd) { padd.addEventListener('click', function () { if (!cur && psel && psel.value === '') { padd.textContent = L.size; return; } addToCart(padd); }); }
    paint();
  });
})();
